const getAverage = (arr: number[]) => arr.reduce((a, b) => a + b, 0) / arr.length;

export default getAverage;
